import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { Flex } from '../Flex/index.js';
import { Box } from '../Box/index.js';
import { useModalContext } from './Modal.js';
import { ModalCloseButton } from './ModalCloseButton.js';

const ModalHeader = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    children,
    dataTestId = 'modal-header',
    closeButton = true,
    ...rest
  } = _ref;
  const {
    headerId
  } = useModalContext();
  return /*#__PURE__*/React__default.createElement(Flex, _extends({
    ref: forwardedRef,
    as: "header",
    borderBottom: "1px solid",
    borderColor: "divider",
    "data-test-id": dataTestId,
    id: headerId,
    justifyContent: "space-between",
    p: "space60"
  }, rest), /*#__PURE__*/React__default.createElement(Box, {
    width: "100%"
  }, children), /*#__PURE__*/React__default.createElement(Box, null, closeButton && /*#__PURE__*/React__default.createElement(ModalCloseButton, null)));
});

export { ModalHeader };
